module.exports = __webpack_public_path__ + "img/silueta.a0c4ee77.png";